<template>
  <div class="info-manage">
    <InfoManagePurchaser v-if="role == 'purchase'"></InfoManagePurchaser>
    <InfoManageSupplier v-if="role == 'supplier'"></InfoManageSupplier>
  </div>
</template>

<script>
import InfoManagePurchaser from "./InfoManagePurchaser.vue";
import InfoManageSupplier from "./InfoManageSupplier.vue";
export default {
  name: "InfoManage",
  components: {
    InfoManagePurchaser,
    InfoManageSupplier,
  },
  data() {
    return {
      role: "", // supplier=供应商, purchase=采购方
    };
  },
  mounted() {
    this.role = localStorage.getItem("role");
  },
};
</script>
